import { FC, useEffect, useMemo, useState } from 'react';
import { List } from 'antd';
import { StyledListItemContent } from 'theme/styled';
import { useSearchParams } from 'react-router-dom';
import { SharedFolder, fetchSharedFolders } from 'services/api/storage';

import FolderItem from './FolderItem';
import { Loading } from 'components/ui';
import FolderContent from './FolderContent';

// import FileItem from './FileItem';

interface IProps {
  id: string;
  setTotal(total: number): void;
}

const Folders: FC<IProps> = ({ id, setTotal }) => {
  const [searchParams] = useSearchParams();
  const [folders, setFolders] = useState<SharedFolder[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    fetchSharedFolders({ patient_id: id })
      .then(data => {
        setFolders(data);
        setTotal(data.length || 0);
      })
      .catch(() => setFolders([]))
      .finally(() => setLoading(false));
  }, [id, setTotal]);

  const folderId = useMemo(() => {
    const pageQuery = searchParams.get('page');
    const parts = pageQuery?.split('/') || [];
    const page = parts[parts.length - 1];

    if (!page || page === 'shared_folders') {
      return null;
    }

    return page;
  }, [searchParams]);

  if (loading) {
    return <Loading />;
  }

  if (folderId) {
    return <FolderContent patientId={id} folderId={folderId} />;
  }

  return (
    <StyledListItemContent>
      <List
        dataSource={folders}
        renderItem={item => (
          <List.Item className="list-content-item">
            <FolderItem
              key={`folder-${item.id}`}
              id={item.id}
              name={item.name}
            />
          </List.Item>
        )}
      />
    </StyledListItemContent>
  );
};

export default Folders;
